import * as React from 'react';
import { TopToolbar, useListContext, List, TextField, DateField, ReferenceField, EditButton, Pagination } from 'react-admin';
import { Card, CardActions, CardContent, CardHeader, Avatar, Grid } from '@material-ui/core';
import PersonIcon from '@material-ui/icons/Person';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import ButtonBase from '@material-ui/core/ButtonBase';
import { Button, Toolbar } from '@material-ui/core';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import { getTsBuildInfoEmitOutputFilePath } from 'typescript';
import parse, { attributesToProps } from 'html-react-parser';
import Box from '@material-ui/core/Box';
import LocationOnIcon from '@material-ui/icons/LocationOn';
import Moment from 'moment';
import SportsIcon from '@material-ui/icons/Sports';
import DateRangeIcon from '@material-ui/icons/DateRange';

import CallIcon from '@material-ui/icons/Call';
import './ContactUs.css';

//import PostPagination from './PostPagination';

const cardStyle = {
    width: 300,
    minHeight: 300,
    margin: '0.5em',
    display: 'inline-block',
    verticalAlign: 'top'
};


const useStyles = makeStyles((theme) =>
    createStyles({
        root: {
            flexGrow: 1,
            width: '500',
            //margin:'0 auto',

        },
        paper: {
            padding: theme.spacing(1),
            margin: 10,
            // maxWidth: 1000,
            // width: '100%',
            backgroundColor: '#F7F7F7',
            // display: 'flex',
            // justifyContent:'center'
        },
        image: {
            //width: 300,
            //height: 300,
            // margin: '0 auto',
        },
        img: {
            margin: 'auto',
            display: 'block',
            maxWidth: '100%',
            maxHeight: '100%',
        },

        playlistContainer: {
            backgroundColor: "lightgrey",
            position: "absolute",
            top: "0",
            bottom: "0",
            right: "0",
            left: "0",
            overflow: "auto",
            [theme.breakpoints.down("sm")]: {
                position: "relative"
            }
        }
    }),
);

const options = {
    replace: domNode =>
    {
        if (domNode.attribs && domNode.name === 'main')
        {
            const props = attributesToProps(domNode.attribs);
            return <div {...props} />;
        }
    }
};

const ListActions = (props) => (
    <TopToolbar>

    </TopToolbar>
);


const AboutUsGrid = () =>
{
    const classes = useStyles();
    const { ids, data, basePath } = useListContext();

    return (

        <div className={classes.root}>


            {ids.map(id => (

                // data.map(id =>
                <Paper className={classes.paper} key={data[id].id}>
                 <p>  Фехтовальный клуб "SALVO" был организован в сентябре 2001 года. С первого дня работы тренера ставили перед собой задачу развивать фехтование в Латвии. Двери нашего клуба всегда открыты для всех. Мы не смотрим на возраст. Для фехтования нет возрастов. В клубе занимаются как девочки так и мальчики. Причем как показывает статистика девочки ничем не хуже мальчиков, девочкам даже удаётся удержать титул лидера годового рейтинга на протяжении всего года. В клубе регулярно проводятся соревнования. Каждые два месяца проходят соревнования розыгрыша годового "GRAND PRIX" после которых на дорожке встречаются восемь лучших саблистов и разыгрывают главный приз. </p>
<p>Фехтовальщики нашего клуба ежегодно выступают на таких соревнованиях ,как Чемпионат Латвии ,Кубок Латвии. Фехтовальщики нашего клуба участвовали во многих официальных соревнованиях: это были соревнования Категории А (соревнования, которые организует Международная Федерация Фехтования (FIE)), Чемпионаты Европы, Чемпионаты мира. </p>
<p>Помимо официальных соревнований часто организовываются поездки на открытые Чемпионаты других стран и международные турниры. Соревнования, на которых наши фехтовальщики борются за призовые места и набираются опыта участия на соревнованиях международного уровня. В клубе приветствуется, если на тренировку приходят мастера фехтования- люди, которые занимаются фехтованием несколько десятков лет.</p>

                </Paper>
                //)}
            ))}

        </div>
    );
};

export const AboutUs = (props) => (
    <List title="All comments" {...props} pagination={false} actions={<ListActions />}>
        <AboutUsGrid id='SS1' />
    </List>
);